<template lang="pug">
    section#duvidas
        .wrapper
            h3
                |Como concorrer às bolsas integrais?
            p
                |· O candidato deve ter renda familiar bruta mensal de até um salário mínimo e meio por pessoa. 
            h3
                |Como concorrer às bolsas de 50%?
            p
                |· A renda familiar bruta mensal deve ser de até três salários mínimos por pessoa. 
                |Além disso, o candidato deve satisfazer a pelo menos uma das condições abaixo:
            p
                |· Ter cursado o ensino médio completo em escola da rede pública;
            p
                |· Ter cursado o ensino médio completo em escola da rede pública e parcialmente em escola da rede privada, 
                |na condição de bolsista integral da própria escola privada;
            p
                |· Ser pessoa com deficiência;
            p
                |· Ser professor da rede pública de ensino, no efetivo exercício do magistério da 
                |educação básica, integrar o quadro de pessoal permanente da instituição pública e concorrer 
                |a bolsas exclusivamente nos cursos de licenciatura. Nesses casos não há requisito de renda.
</template>

<script>
export default {
    name: "section-duvidas"
}
</script>

<style lang="stylus" scoped src="./Duvidas.styl"></style>